/////////////////////// class functions definition
/*global jQuery, $, Kinetic, KeyboardJS,
	Shooter, parseLinkHash*/

Shooter.prototype = jQuery.extend( {}, commonGameFunctions, {
gameName: "Shooter",
/**
	If the setting "newLetters" is set, we want to generate more of them (for better practice).
	 So this function sets this.lettersToGenerateFrom so that it contains 1x this.c.allowedLetters
	 (which btw. contain also new letters) and 3x this.c.newLetters.
	The only exception is SHIFT level - we want to generate 3x more allowedLetters than newLetters,
	 so the player does not get overwhelmed by shift letters and the ratio is also more realistic.
*/
setupLettersSet: function() {
	this.lettersToGenerateFrom = this.c.allowedLetters;

	if (this.c.newLetters) {
		// if the new letters are capitals (typed using SHIFT), we want only 25% of them in the field, not 75% as in other levels
		if (this.c.newLetters == 'ABCDEFGHIJKLMNOPQRSTUVWXYZ') {
			var knownLetters = this.c.allowedLetters.replace(this.c.newLetters, '');
			var koef = Math.floor(3 * this.c.newLetters.length / knownLetters.length);	// only 25% of letters should be capital (using SHIFT)
			this.lettersToGenerateFrom += this.repeatString(knownLetters, koef);
		}
		else {
			var koef = Math.floor(3 * this.c.allowedLetters.length / this.c.newLetters.length);	// TODO move the ratio (the first number) to the round settins
			this.lettersToGenerateFrom += this.repeatString(this.c.newLetters, koef);
		}
	}
},

sendLetter: function() {
	if (!this.lettersToGenerateFrom) {
		this.setupLettersSet();
	}

	// Generate random travel time, random letter and random start Y-point
	var rand = Math.floor(Math.random() * this.lettersToGenerateFrom.length);
	var letterText = this.lettersToGenerateFrom.charAt(rand);
	var i = 0;
	while (letterText == this.lastKilledLetter && i < 5) {
		// If the letter is the same as was the last one killed, try to generate different
		rand = Math.floor(Math.random() * this.lettersToGenerateFrom.length);
		letterText = this.lettersToGenerateFrom.charAt(rand);
		i++;
	}

	var travelTime = Math.round(Math.random() * (this.maxLetterTravelTime - this.minLetterTravelTime)) + this.minLetterTravelTime;
	var startX = this.gameRegion.getX() + Math.round(Math.random() * (this.gameRegion.getWidth() - 25));

	if (!this.gamePlaying) { return; }

	// Speedup for neverending game, use speedUpCoeficient every 10 seconds:
	if (this.c.targetPoints == 0 && (this.getTypingTime() - this.lastSpeedup)/1000 > this.c.neverendingSpeedupDelay) {
		this.lastSpeedup = this.getTypingTime()
		this.nextLetterMinInterval *= this.c.speedupCoeficient;
		this.nextLetterMaxInterval *= this.c.speedupCoeficient;
	}

	var rand;
	if (!this.gamePaused) {
		var time = new Date().getTime();
		if((time - this.lastSendTime) < this.nextLetterMinInterval - 10 && this.numberOfFlying > 0) { return; }
		this.lastSendTime = time;

		var startY = 0;
		var targetY = this.gameRegion.getHeight() - 20;

		var letterAttributes = {
			x: startX,
			y: startY,
			text: letterText,
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'bold',
			fontSize: 25,
			fill: this.common.colors.text.black,
			textDecoration: 'none'
		};
		if (letterText != letterText.toLowerCase()) {

			letterAttributes.fontSize = 35;

			if(this.common.colors.text.upperCase) {
				letterAttributes.fill = this.common.colors.text.upperCase;	
				letterAttributes.stroke = this.common.colors.text.black;
			}
			else {
				letterAttributes.stroke = this.common.colors.text.black;
				letterAttributes.fill = this.g.allBackgroundColor;
			}

		}
		var letter = new Kinetic.Text(letterAttributes);

		this.layers.letters_layer.add(letter);
		//this.layers['letters_layer'].draw();

		var tween = new Kinetic.Tween({
			node: letter,
			duration: travelTime/1000,
			y: targetY,
			onFinish: function() {
				t.checkTimeouts();
			}
		});
		tween.play();

		var i = this.flyingLetters.push({
			letterText: letterText,
			letter: letter,
			tween: tween,
			fired: false,
			startTime: time,
			travelTime: travelTime,
			startY: startY,
			targetY: targetY
		});
		this.timeouts.push([i-1, time+travelTime]);
		// Set random interval for the next letter
		rand = Math.round(Math.random() * (this.nextLetterMaxInterval - this.nextLetterMinInterval)) + this.nextLetterMinInterval;
		this.numberOfFlying++;
	}
	var t = this;
	setTimeout(function() { t.sendLetter(); }, rand);
},

checkTimeouts: function() {
	// We dont't want to check, when game is pause (before restoring all timetous to the new correct time)
	if (this.gamePaused || this.gameOver) return;
	// Filter out events for fired letters
	var t = this;
	this.timeouts = jQuery.grep(this.timeouts, function( element ) {
		return(t.flyingLetters[element[0]] && !t.flyingLetters[element[0]].fired);
	});
	// Test if there is any passed timeout
	var time = new Date().getTime();
	var arr = jQuery.grep(this.timeouts, function( element ) {
		return(element[1] <= time);
	});
	// Each item drops number of lives
	for (index = 0; index < arr.length; index++) {
		this.stopLetter(arr[index][0], this.common.colors.text.wrong);
		this.results.points += this.c.pointsPerMiss;
		//console.log("Timeout písmena "+arr[index][0]+" ("+this.flyingLetters[arr[index][0]].letterText+")");
		this.doErrorFlash();
		
		if (this.livesEnabled) {
			this.removeLive();
		}
	}
	if (this.results.points < 0) this.results.points = 0;
	this.drawResults();
},

manageLetter: function(letter) {
	if (this.gameOver || this.gamePaused) { return; }
	if (!this.gamePlaying) {
		if (letter == ' ') {	// only start by SPACE
			this.startGame();
		}
		return;
	}

	this.processTimeBetweenLetters();
	
	this.results.keystrokes += this.letterToKeystrokes(letter);

	var lowestPosition = 0;
	var lowestIndex = 0;

	var catched = false;
	var killed = 0; // number of killed letters - used for point count
	var index, x;
	// Iterate througt flyingLetters from top, because there are the newest letters
	for (index = this.flyingLetters.length - 1; index >= 0; index--) {
		if(!this.flyingLetters[index].fired && this.flyingLetters[index].letterText == letter) {
			catched = true;
			if (this.c.killAll) {
				this.stopLetter(index); killed += 1;
			} // kill all coresponding letters
			else { // remember letter, if it is the lowest letter
				y = this.flyingLetters[index].letter.getY();
				if (y > lowestPosition) {
					lowestPosition = y;
					lowestIndex = index;
				}
			}
		}
	}

	if (!this.c.killAll && catched) {
		this.stopLetter(lowestIndex);
		killed = 1;
	}

    app.gameData.captureLetter(letter, false, !catched)

	if (catched) {
		this.lastKilledLetter = letter;
		if (killed > 1) {
			var bonus = killed/2;
			this.results.points += this.c.pointsPerGood + bonus;
		}
		else this.results.points += this.c.pointsPerGood;
		this.results.good_keystrokes += this.letterToKeystrokes(letter);
	} else {
		this.results.points += this.c.pointsPerMiss;
		this.results.mistakes++;
		this.doErrorFlash();

		if (this.c.livesEnabled) {
			this.removeLive();
		}

		if (this.allowSounds) {
			this.sounds.error.play();
		}
	}

	if (this.results.points < 0) this.results.points = 0;
	this.drawResults();

	if (this.results.points >= this.c.targetPoints && this.c.targetPoints != 0) {
		this.endGame();
	}

	var progress = this.getProgress();
	if (Math.floor(progress / 25) > Math.floor(this.lastProgressValue / 25)) {
		this.playProgressSound(Math.floor(progress / 25));
	}
	this.lastProgressValue = progress;

},

getProgress: function() {
	return Math.round(this.results.points / this.c.targetPoints * 100);
},



stopLetter: function(index, color) {
	color = color || this.g.levelColor;
	if (this.flyingLetters[index].fired) { return; }
	this.flyingLetters[index].fired = true;
	this.flyingLetters[index].tween.pause();
	this.numberOfFlying--;

	var t = this;
	var n = this.flyingLetters[index].letter;
	n.setFill(color);
	new Kinetic.Tween({
		node: n,
		scaleX: 5,
		scaleY: 5,
		x: n.getX()-(n.getWidth()*2.5),
		y: n.getY()-(n.getHeight()*2.5),
		opacity: 0,
		duration: 0.2,
		onFinish: function() {
			t.flyingLetters[index].letter.remove();
			//t.flyingLetters.splice(index, 1);
		}
	}).play();

	if (this.numberOfFlying <= 0) {
		this.nextLetterMinInterval *= this.c.speedupCoeficient;
		this.nextLetterMaxInterval *= this.c.speedupCoeficient;
	}
},

// METODA getMistakes NAIMPLEMENTOVÁNA V SAMOSTATNÉM MODULU
getMistakes: app.shooter.getMistakes,

drawResults: function() {
	if (this.c.targetPoints != 0) {
		if (this.results.points > this.c.targetPoints) this.results.points = this.c.targetPoints;

		var pointsStatus = 100 * this.results.points / this.c.targetPoints;
		this.pointBar.text.setText(pointsStatus.toFixed(0)+"%");

		var newWidth = this.resultsBarWidth*pointsStatus/100 + 4;
		if(newWidth < 30) newWidth = 30;

		var newX = (this.pointBar.text.x() + ((this.resultsBarWidth*pointsStatus/100) - this.pointBar.text.x())) - this.pointBar.text.width() - 5;
		if(newX < 5) newX = 5;
		var t = this;
		new Kinetic.Tween({
			node: this.pointBar.rect,
			duration: 0.2,
			width: newWidth,
		}).play();
		new Kinetic.Tween({
			node: this.pointBar.text,
			duration: 0.2,
			x: newX
		}).play();
		/*var newWidth = (0.2 + 0.8*(this.results.points / this.c.targetPoints))*this.heartPictureFullWidth;
		var newHeight = (0.2 + 0.8*(this.results.points / this.c.targetPoints))*this.heartPictureFullHeight;
		new Kinetic.Tween({
			node: this.heartPicture,
			duration: 0.4,
			x: this.g.sidebarWidth/2 - newWidth/2,
			y: this.g.heartTopOffset - newHeight/2,
			width: newWidth,
			height: newHeight
		}).play();

		var pointsStatus = 100 * this.results.points / this.c.targetPoints;
		this.pointsSlider.text.setText(pointsStatus.toFixed(0)+"%");
		this.pointsSlider.text.setX(this.pointsSlider.rect.getX() + this.pointsSlider.rect.getWidth()/2 - this.pointsSlider.text.getWidth()/2);
		new Kinetic.Tween({
			node: this.pointsSlider.box,
			duration: 0.4,
			x: this.resultsBarWidth*pointsStatus/100
		}).play();
	}
	else {
		this.currentPoints.setText(this.results.points.toFixed(0));
		this.currentAccuracy.setText((100*this.results.good_keystrokes/this.results.keystrokes).toFixed(1)+"%");

		//this.currentPoints.setX(this.g.sidebarWidth/2 - this.currentPoints.getWidth()/2);
		//this.currentAccuracy.setX(this.g.sidebarWidth/2 - this.currentAccuracy.getWidth()/2);

		var newWidth, newHeight;
		if (this.results.points % 2 == 1) {
			newWidth = 0.5*this.heartPictureFullWidth;
			newHeight = 0.5*this.heartPictureFullHeight;
		} else {
			newWidth = 0.3*this.heartPictureFullWidth;
			newHeight = 0.3*this.heartPictureFullHeight;
		}
		new Kinetic.Tween({
			node: this.heartPicture,
			duration: 0.8,
			x: this.g.sidebarWidth/2 - newWidth/2,
			y: this.g.heartTopOffset - newHeight/2,
			width: newWidth,
			height: newHeight
		}).play();

		this.currentPoints.getLayer().draw();*/
	}
	else {
		this.currentPoints.setText(this.results.points.toFixed(0));
		this.currentAccuracy.setText(this.getAccuracy().toFixed(1)+"%");
		//if(!isNaN((100*this.results.good_keystrokes/this.results.keystrokes).toFixed(1)))this.currentAccuracy.setText((100*this.results.good_keystrokes/this.results.keystrokes).toFixed(1)+"%");
		//else this.currentAccuracy.setText("0%");

		//this.currentPoints.setX(this.g.sidebarWidth/2 - this.currentPoints.getWidth()/2);
		//this.currentAccuracy.setX(this.g.sidebarWidth/2 - this.currentAccuracy.getWidth()/2);
		this.layers.pointsLayer.draw();
		var newWidth, newHeight;
		if (this.results.points % 2 == 1) {
			newWidth = 0.5*this.heartPictureFullWidth;
			newHeight = 0.5*this.heartPictureFullHeight;
		} else {
			newWidth = 0.3*this.heartPictureFullWidth;
			newHeight = 0.3*this.heartPictureFullHeight;
		}
		/*new Kinetic.Tween({
			node: this.heartPicture,
			duration: 0.8,
			x: this.g.sidebarWidth/2 - newWidth/2,
			y: this.g.heartTopOffset - newHeight/2,
			width: newWidth,
			height: newHeight
		}).play();*/
	}
},

startGame: function() {

	const stopStartGame = this.onStartGame();
	if(stopStartGame === true) { return; }
	
	this.hideCursor();

	// Start countdown only once
	if (this.gameStarting || this.gamePlaying) return;
	this.gameStarting = true;
	this.gameUnstarted = false;
    app.gameData.captureEvent({name: app.gameData.getEventName("startGame"), game: this.gameName})

	this.tooltipsStart();
	new Kinetic.Tween({
		node: this.layers.message_layer,
		duration: 0.3,
		opacity: 0,
	}).play();
	if (isFirefox) this.layers.message_layer.visible(false);

	var t = this;
	this.countdownCounting();
	setTimeout(function() {
		t.gamePlaying = true;
		t.gameStarting = false;
		t.startTime = new Date().getTime();
		t.sendLetter();

		new Kinetic.Tween({
			node: t.layers.countdown_layer,
			duration: 0.3,
			opacity: 0,
		}).play();
		if (isFirefox) t.layers.countdown_layer.visible(false);
	}, this.c.countdownStart * 1000);

	var t = this;
	this.timer = setInterval(function() {
		if (t.gamePaused || !t.gamePlaying) return;

		if (t.currentTime) {
			if(t.c.gameEndCondition === t.GAME_CONDITION_TIME) {
				var remainingTime = t.getRemainingTime();
				t.currentTime.setText(t.formatTime(remainingTime));
				if(remainingTime <= 0) t.endGame();
			}
			else t.currentTime.setText(t.getFormattedTime());
			t.currentTime.getLayer().draw();
		}

		// pokud je hra nekonecna, zkracujeme interval objevu novych pismen (jen v lichych desitkach vterin, tzn. do 9. sekundy ne, 10.-19. ano, 20.-29. ne atd.)
		if (t.c.endless && (Math.floor(t.getTypingTime()/10000) % 2) == 1) {
			if (t.letterMinInterval > 50) {
				t.letterMinInterval -= (t.letterMinInterval/400);
			}
			if (t.letterMaxInterval > 500) {
				t.letterMaxInterval -= ((t.letterMaxInterval-500)/400);
			}
		}
	}, 100);
	if(typeof this.progressBarTip !== 'undefined') this.progressBarTip.hide();
	if(typeof this.livesTip !== 'undefined') this.livesTip.hide();

	if(this.publicContestId) {
		this.preventRefreshInPublicContest();
	}

	this.startWatchingKeyboard();

	var resultsToSave = this.getResults(0, 0);
	t.saveResults(resultsToSave);
},
pauseGame: function() {
	if (true /*this.gameOver || !this.gamePlaying*/) { return; }

	var index;
	if (this.gamePaused) {
		// Action: resume
		var difference = new Date().getTime() - this.startPauseTime;
		for (index = 0; index < this.timeouts.length; index++) this.timeouts[index][1] += difference;
		for (index = this.flyingLetters.length - 1; index >= 0; index--) {
			if (!this.flyingLetters[index].fired) {
				this.flyingLetters[index].tween.play();
				this.flyingLetters[index].letter.setOpacity(1);
				if (isFirefox) this.flyingLetters[index].letter.setFill(this.common.colors.text.black);
				this.layers.letters_layer.draw();
			}
		}
	} else {
		// Action: pause
		for (index = this.flyingLetters.length - 1; index >= 0; index--) {
			if (!this.flyingLetters[index].fired) {
				this.flyingLetters[index].tween.pause();
				this.flyingLetters[index].letter.setOpacity(0.2);
				if (isFirefox) this.flyingLetters[index].letter.setFill('#c0c0c0');
				this.layers.letters_layer.draw();
			}
		}
	}

	this.genericPauseGame();
},

stopGame: function() {
	if (!this.gamePaused) this.pauseGame();
	var index;
	for (index = this.flyingLetters.length - 1; index >= 0; index--) {
		if (!this.flyingLetters[index].fired) this.flyingLetters[index].letter.remove();
	}
},

endGame: function(endedForNotPlaying) {

	this.showCursor();

	if (this.gameOver || !this.gamePlaying ) { return; }
	this.setGameVariablesOnGameEnd();
	clearInterval(this.gameTimer);
    app.gameData.captureEvent({name: app.gameData.getEventName("endGame"), game: this.gameName});
    this.stopWatchingKeyboard();

	var won = 0;
	var color = this.common.colors.text.wrong;
	this.sweepingLine.setFill(this.common.colors.sweepingLine);
	this.sweepingLine.setShadowColor(this.common.colors.sweepingLine);

	if(endedForNotPlaying != 1) {
		if (this.results.points >= this.c.targetPoints) { 
			won = 1; 
			color = this.g.levelColor; 
			this.sweepingLine.setFill(color);
			this.sweepingLine.setShadowColor(color);
		}
	}

	if (this.allowSounds) {
		if (won) {
			this.sounds.victory.play();
		}
		else {
			this.sounds.loss.play();
		}
	}

	var t = this;
	var oldY = this.sweepingLine.getY();
	var newY = -5;
	var animationTime = 2000;
	var anim = new Kinetic.Animation(function(frame) {
		var y = oldY + (newY - oldY) * frame.time/animationTime;
		t.sweepingLine.setY(y);
		if (frame.time > animationTime) anim.stop();
		for (index = t.flyingLetters.length - 1; index >= 0; index--) {
			var letter = t.flyingLetters[index];
			if (!letter.fired) {
				var time = new Date().getTime();
				var letterY = letter.letter.getY();
				if (letterY > y) t.stopLetter(index, color);
			}
		}
	}, this.layers.letters_layer);
	anim.start();

	var resultsToSave = this.getResults(won)

	var links = this.l;
    var resultsToShow = {
		roundId: this.c.roundId,
		stars: this.getStars(won),
        won: won,
        playerRank: this.getPlayerRank(),
        mistakeCount: this.results.mistakes,
        playerSpeed: this.getSpeed(),
		mistakes: resultsToSave.mistakes,
		gameTypeId: 2,
		time: Math.round(Number(resultsToSave.time)),
    }


	setTimeout(function (){
		t.resetGameEnvironment();
		t.showResults(resultsToShow, t);
		t.saveResults(resultsToSave);
	}, animationTime);

	this.onEndGame();
},


draw: function() {
	Kinetic.pixelRatio = 1;		// fix for zoom-out in browser
	this.soundsInit();

	// Copy from constants to speed them up during the game
	this.nextLetterMinInterval = this.c.nextLetterMinInterval;
	this.nextLetterMaxInterval = this.c.nextLetterMaxInterval;
	this.minLetterTravelTime = this.c.minLetterTravelTime;
	this.maxLetterTravelTime = this.c.maxLetterTravelTime;
	this.lastSpeedup = 0;

	var t = this;
	this.stage = new Kinetic.Stage({
		container: this.containerName,
		width: this.g.width,
		height: this.g.height
	});
	this.layers = { };


	this.setKeyboard({
		'letter': this.manageLetter,
		'specialLetters': {
			' ': nop  // No letter could be shooted down by spacebar
		},
		'specialKeys': {
			'Spacebar': this.startGame,
			'Esc': this.pauseGame
		},
		'preventPropagation': [ 'Spacebar', 'Backspace', 'Esc' ]
	});


	this.layers.background_layer = new Kinetic.Layer();

	var allBackground = new Kinetic.Rect({
		width: this.stage.getWidth(),
		height: this.stage.getHeight(),
		fill: this.g.allBackgroundColor,
		opacity: 1,
		//cornerRadius: 5
	});

	/*var sidebarBackground = new Kinetic.Rect({
		x: this.stage.getWidth() - this.g.sidebarWidth,
		y: 0,
		width: this.g.sidebarWidth,
		height: this.stage.getHeight(),
		fill: this.g.backgroundColor,
		cornerRadius: 5
	});*/

	/*var chameleonPictureObj = new Image();
	var chameleonPicture = new Kinetic.Image({
		image: chameleonPictureObj,
		width: 215,
		height: 370
	});
	chameleonPictureObj.onload = function() { chameleonPicture.draw(); };
	chameleonPictureObj.src = this.l.imgUrl+'chameleon_love.png';
	*/

	/*var levelLabel = new Kinetic.Text({
		y: 10,
		text: this.t.level+" "+this.c.gameId,
		fontStyle: 'bold',
		fontSize: 15,
		fill: 'white',
		shadowColor: 'white',
		shadowBlur: 10,
		shadowOpacity: 0.8
	});
	levelLabel.setX(this.stage.getWidth() - this.g.sidebarWidth/2 - levelLabel.getWidth()/2);*/

	this.layers.background_layer
		.add(allBackground);
		//.add(sidebarBackground)
		//.add(chameleonPicture)
		//.add(levelLabel);
	this.stage.add(this.layers.background_layer);

	this.layers.letters_layer = new Kinetic.Layer({
		x: 0,
		y: this.g.headerHeight,
		width: this.stage.getWidth(),
		height: this.stage.getHeight() - this.g.headerHeight
	});

	this.gameBackground = new Kinetic.Rect({
		width: this.layers.letters_layer.getWidth(),
		height: this.layers.letters_layer.getHeight(),
		//cornerRadius: 10,
		fill: this.g.allBackgroundColor,
	});
	this.errorFlash = this.gameBackground.clone({
		fill: 'red',
		opacity: 0
	});

	this.sweepingLine = this.gameBackground.clone({
		y: this.stage.getHeight(),
		height: 3,
		fill: this.common.colors.sweepingLine,
		shadowColor: this.common.colors.sweepingLine,
		shadowOffset: {x:0, y:2},
		shadowBlur: 7
	});

	this.gameRegion = new Kinetic.Rect({
		x: this.g.gameRegionLeftOffset,
		width: this.layers.letters_layer.getWidth() - this.g.gameRegionLeftOffset - this.g.gameRegionRightOffset,
		height: this.layers.letters_layer.getHeight(),
		//fill: 'yellow'
	});

	this.layers.letters_layer
		.add(this.gameBackground)
		.add(this.gameRegion)
		.add(this.errorFlash)
		.add(this.sweepingLine);
	this.stage.add(this.layers.letters_layer);


	this.layers.header_layer = new Kinetic.Layer();
	var headerWhiteBackground = new Kinetic.Rect({
		width: this.stage.getWidth(),
		height: this.g.headerHeight,
		fill: this.g.allBackgroundColor,
		opacity: 1,
	});
	var headerBackground = new Kinetic.Rect({
		width: this.stage.getWidth(),
		height: this.g.headerHeight,
		fill: this.g.backgroundColor,
		opacity: this.g.opacity,
	});
	this.layers.header_layer.add(headerWhiteBackground);
	this.layers.header_layer.add(headerBackground);
	this.stage.add(this.layers.header_layer);

	// Heart start
	/*this.layers.heart_layer = new Kinetic.Layer({
		x: this.stage.getWidth() - this.g.sidebarWidth,
		y: 0,
		width: this.g.sidebarWidth
	});
	this.heartPictureFullWidth = 130;
	this.heartPictureFullHeight = 118;
	var heartPictureObj = new Image();
	this.heartPicture = new Kinetic.Image({
		image: heartPictureObj,
		x: this.g.sidebarWidth/2 - (this.heartPictureFullWidth*0.2)/2,
		y: this.g.heartTopOffset - (this.heartPictureFullHeight*0.2)/2,
		width: this.heartPictureFullWidth*0.2,
		height: this.heartPictureFullHeight*0.2
	});
	var t = this;
	heartPictureObj.onload = function() { t.heartPicture.draw(); };
	heartPictureObj.src = this.l.imgUrl+'heart.png';

	this.layers.heart_layer.add(this.heartPicture);
	// Heart end
	*/

	if (this.c.targetPoints != 0) {
		this.addLivesLayer();
		this.layers.lives_layer.setY(5).draw();
		this.removeStartLives();

		this.layers.slider_layer = new Kinetic.Layer({
			//x: this.stage.getWidth() - this.g.sidebarWidth,
			x: this.stage.getWidth()/3,
			y: 0,
			width: this.stage.getWidth()/3
		});
		//this.resultsBarHeight = this.layers.slider_layer.getHeight()/2;
		//this.resultsBarTop = this.layers.slider_layer.getHeight()/2 - this.resultsBarHeight/2 - 20;
		this.resultsBarWidth = this.layers.slider_layer.getWidth();
		this.drawResultsSlider(this.layers.slider_layer, true, false);
		this.stage.add(this.layers.slider_layer);
	} else {
		var centerHeadBar = 50;
		var timeStr = t.formatTime(t.c.timeLimit);
		if(this.c.gameEndCondition !== this.GAME_CONDITION_TIME) {
			this.addLivesLayer();
			this.layers.lives_layer.setY(5).draw();
			this.removeStartLives();
			centerHeadBar = 0;
			timeStr = "0:00";
		}

		this.layers.pointsLayer = new Kinetic.Layer({
			//x: this.stage.getWidth() - this.g.sidebarWidth,
			x: this.stage.getWidth()/4-centerHeadBar,
			y: 0,
			width: this.stage.getWidth()/2
		});
		var captionPoints = new Kinetic.Text({
			//y: this.heartPicture.getY() + this.heartPicture.getHeight() + 40,
			y: 15,
			text: this.t.results.points+': ',
			fontFamily: 'Open Sans, Arial',
			fontStyle: 'bold',
			fontSize: 20,
			fill: this.g.allBackgroundColor,
			//shadowColor: 'white',
			shadowBlur: 2,
			shadowOpacity: 0.5
		});
		this.currentPoints = captionPoints.clone({
			x: 105,
			text: 0
		});

		var captionAccuracy = captionPoints.clone({
			x: captionPoints.getX() + 180,
			text: this.t.results.accuracy+': '
		});
		this.currentAccuracy = captionAccuracy.clone({
			x: captionPoints.getX() + 280,
			text: '---'
		});

		var captionTime = captionPoints.clone({
			x: captionPoints.getX() + 380,
			text: this.t.results.timeElapsed+': '
		});
		this.currentTime = captionTime.clone({
			x: captionPoints.getX() + 430,
			text: timeStr
		});

		captionPoints.setX(captionPoints.getWidth()/2);
		//captionAccuracy.setX(this.g.sidebarWidth/2 - captionAccuracy.getWidth()/2);
		//this.currentPoints.setX(this.g.sidebarWidth/2 - this.currentPoints.getWidth()/2);
		//this.currentAccuracy.setX(this.g.sidebarWidth/2 - this.currentAccuracy.getWidth()/2);

		this.layers.pointsLayer.add(captionPoints).add(this.currentPoints);
		this.layers.pointsLayer.add(captionAccuracy).add(this.currentAccuracy);
		this.layers.pointsLayer.add(captionTime).add(this.currentTime);

		this.stage.add(this.layers.pointsLayer);

	}

	// Tooltips start
	var t = this;
	if (this.c.tooltips.hasOwnProperty('lives')) {
		this.tooltips['lives'] = new Kinetic.Group({
			x: 10,
			y: 35
		});
			var tooltipLivesObj = new Image();
			tooltipLivesObj.src = this.l.imgUrl+'hint_lives.png';
			tooltipLivesObj.onload = function() { t.tooltips['lives'].draw(); };
			var tooltipLives = new Kinetic.Image({image: tooltipLivesObj});
		this.tooltips['lives'].add(tooltipLives);
	}

	if (this.c.tooltips.hasOwnProperty('progress')) {
		this.tooltips['progress'] = new Kinetic.Group({
			x: 550,
			y: 0
		});
			var tooltipProgressObj = new Image();
			tooltipProgressObj.src = this.l.imgUrl+'hint_progress.png';
			tooltipProgressObj.onload = function() { t.tooltips['progress'].draw(); };
			var tooltipProgress = new Kinetic.Image({image: tooltipProgressObj});
		this.tooltips['progress'].add(tooltipProgress);
	}

	if(this.c.tooltips.firstRound){
		this.addTooltip({
			text: localizedTexts.games.need100perc,
			posX: 620,
			posY: 8,
			opacity: 1
		},{
			image: 'arrow7.svg',
			posX: 544,
			posY: 16,
			width: 65,
			height: 16,
			opacity: 1
		}, function(to){
			t.progressBarTip = to;
		});

		this.addTooltip({
			text: localizedTexts.games.warning,
			posX: 50,
			posY: 80,
			opacity: 1
		},{
			image: 'arrow1.svg',
			posX: 10,
			posY: 40,
			width: 40,
			height: 50,
			opacity: 1
		}, function(to){
			t.livesTip = to;
		});
	}
	
	this.tooltipsDraw();
	// Tooltips end

	this.addCountdownLayer(this.gameRegion.getX() + this.gameRegion.getWidth() / 2, this.gameRegion.getY() + this.gameRegion.getHeight() /2);
	
	if(!this.needToBuyFullVersion) { this.addMessageLayer(); } 
	else { this.showBuyFullVersionInfo(); }
	
	this.addPauseLayer();

	this.setupStartButton();
},

restartGame: function() {

	//override game restart in public contest - we need to reload texts and other stuff and this is the easiest way
	if(this.publicContestId) 
	{
		restartLink = $('.link-restartGame.blue').attr('href');
		this.restartInPublicContest(restartLink);
		return;
	}

	this.resetGameEnvironment();
	this.resetGameVariables();
	this.reloadAfterPlayTexts();
	this.reloadPlayerXpInfo();
	this.draw();
}


}); /////////////////////// end of the class functions definition
